import { render } from "./BtnVocalize.vue?vue&type=template&id=47c7af56&scoped=true"
import script from "./BtnVocalize.vue?vue&type=script&lang=js"
export * from "./BtnVocalize.vue?vue&type=script&lang=js"

import "@/css/components/btn-vocalize.css?vue&type=style&index=0&id=47c7af56&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c7af56"]])

export default __exports__